import {UyapRequest} from "./UyapRequest";
import app from "@/main";
import {ISorguSonuc} from "./CommonInterfaces";

export interface SskEmekliTalep {
    dosyaId: string,
    kisiKurumId: number,
}

export interface SskEmekliCevap extends ISorguSonuc<ISskEmekliSonuc>{}

export interface ISskEmekliSonuc {
    // DEV-3514: 19.09.2026 UYAP güncellemesinden beri kayıtlar emekliKaydi4a altında geliyor;
    // emekliKaydi4AList eski şema. Kayıtları doğrudan değil sskEmekliKayitlari() ile okuyun.
    emekliKaydi4a?: Array<ISskEmekliKaydi>,
    emekliKaydi4AList?: Array<ISskEmekliKaydi>,
    hataKodu: 0 | 1 | 995 | number,      // başarılı | aylık ödenmemektedir (kayıt yine gelir) | kayıt bulunamadı
    hataMesaji: string
}

// Tutarlar en-US biçiminde metin geliyor ("19,578.14"); tahno, aylikBaglayanUnite gibi alanlar boşluklu olabilir.
export interface ISskEmekliKaydi {
    abo1: string,                   // aylık bağlama oranı
    abo2?: string,
    abo3?: string,
    adi: string,
    soyadi: string,
    aylik: string,
    aylikBaglayanUnite: string,
    bankaadi: string,
    bankakodu?: string,
    subeadi: string,
    subekodu?: string,
    birikmis: string,
    donem: string,                  // "EYLÜL/2026"
    durkod: string,
    ek: string,
    geltar: string,                 // aylık başlangıç tarihi, "01.01.2024"
    hataCode: number,
    hataMessage: string,            // "Aylık Ödenmemektedir" gibi
    kesinti: string,
    kod5: string,
    mernisNo: string,
    pay: number,
    payda: number,
    sicno: string,
    tahno: string
}

// DEV-3514: SSK emekli kayıtlarını okuyan tek yer; yeni (emekliKaydi4a) ve eski (emekliKaydi4AList) şemayı kabul eder.
export function sskEmekliKayitlari(sonuc?: Partial<ISskEmekliSonuc> | string | null): Array<ISskEmekliKaydi> {
    if (!sonuc || typeof sonuc !== "object")
        return [];
    const kayitlar = sonuc.emekliKaydi4a ?? sonuc.emekliKaydi4AList;
    return Array.isArray(kayitlar) ? kayitlar : [];
}


export default class SskEmekli extends UyapRequest<SskEmekliTalep, SskEmekliCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "SSK emekli bilgileri sorgulanıyor...";
    }


    /**
     * Snapshot deposundaki alan adı (picker `name`). Taze kayıtta ham gövde
     * varsa okunur (B1: `zincireGirer` erken elemesi kaldırıldı); normalizer'ı
     * yok (fallback hash) olduğundan kurucu yedeği (gövdesiz eski kayıtlar
     * için) bu alanı kapsamıyor.
     *
     * NOT: DEV-3514 (develop) öncesi bu sınıf `DosyaBorclu.queryBorcluEmekliKamu`de
     * de kullanılıyordu; kamu emeklisi artık ayrı `KamuEmekli` servisinde ve
     * `emeklikamu` alanını o bildiriyor. Bu sınıf yalnız `emeklissk` döner.
     */
    protected snapshotAlani(): string | null {
        return "emeklissk";
    }

    cache() {
        return {
            active: true,
            ttl: (60 * 24), //* 1 gun
            key: "SskEmekli_" + app.$uyapHelper.hash(this.talepData)
        };
    }

    getMockResponse(): any {
        // DEV-3514: dev3514-ornekler.json'daki gerçek 995 cevabı (parse öncesi hali). Mock'ta herkes SSK emeklisi
        // görünmesin (toplu haciz maaş haczi rozeti) diye başarılı değil "kayıt yok" cevabı.
        return {"borcluBilgileri":{"kisiTumDVO":{"olumKaydi":false,"isAvukat":false,"isGecerlilikAktifAvukat":false,"isNoter":false,"isTarafUyari":false,"isHakimSavci":false,"mernisDegisiklikVarmi":false,"mernisDegisiklikNedeni":"","yabanci":false,"mavikart":false,"sorguTuru":0,"tcKimlikNo":"9********96","adi":"ZA***","soyadi":"DE***","babaAdi":"İ****","anaAdi":"Z****","dogumTarihiStr":"1111","aktifMernisAdresiSorgusu":true,"hasOlumKaydi":false},"kisiKurumId":17918092,"turu":0},"sorgulayanBilgileri":"Av***","portalTuru":2,"sorguTarihi":"22/09/2026 15:41","sorguSonucDVO":{"hataKodu":995,"hataMesaji":"Kayıt Bulunamadı...","isNew":true},"sorgulamaTuru":"SSK Emeklisi","sorguSonucu":true,"hasError":false,"hasData":false,"isMock":false};
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'borclu_bilgileri_goruntule_sgk_sskEmekliBilgileri.ajx';
    }

    async parse(data: any): Promise<SskEmekliCevap> {
        // Güncel serviste kayıt bulunamadığında sorguSonucDVO hiç dönmüyor;
        // bu yüzden hataMesaji'ye null-safe erişip varsayılan mesaj veriyoruz.
        const sonuc = data.sorguSonucDVO;
        // DEV-3514: kimlik bilgisi eksikse sorguSonucDVO düz hata metni olarak geliyor.
        if (typeof sonuc === "string" && sonuc) {
            data.message = sonuc;
            data.sorguSonucu = false;
        } else if (!sonuc || sonuc.hataKodu != 0) {
            data.message = sonuc?.hataMesaji || "Kayıt bulunamadı";
            data.sorguSonucu = false;
        } else
            data.message =  "SGK Emekli bilgisi var";
        return data;
    }

}